export const PackageTypes = {
  GET_INFO_LICENCSE: 'GET_INFO_LICENCSE',
  GET_PACKAGES: 'GET_PACKAGES',
  GET_PROFILE_INFO: 'GET_PROFILE_INFO',
  POST_ORDER: 'POST_ORDER',
  POST_PACKAGE: 'POST_PACKAGE',
  POST_LICENCE: 'POST_LICENCE',
}
